<div class="selecteur-periode">
	<div class="periode-input">
		<p-button icon="pi pi-chevron-left"
		          [text]="true"
		          severity="secondary"
		          [disabled]="estPeriodePrecedenteDesactivee()"
		          (onClick)="retournerPeriodePrecedente()">
		</p-button>
		@if (mode() === MODE_SELECTEUR_PERIODE.JOUR) {
			<span>{{ journee().toDate() | date: 'EEEE dd/MM' | premiereLettreMajusculePipe }}</span>
		} @else {
			<span>{{ 'GESTION_NAVETTE.TRAJETS.SEMAINE' | translate: { numero: numeroSemaine() } }}</span>
		}
		<p-button icon="pi pi-chevron-right"
		          [text]="true"
		          severity="secondary"
		          [disabled]="boutonsDesactives()"
		          (onClick)="passerPeriodeSuivante()">
		</p-button>
	</div>

	<p-button type="button"
	          class="bouton-aujourdhui"
	          (onClick)="retournerALaPeriodeActuelle()"
	          icon="pi pi-clock"
	          [disabled]="boutonsDesactives()"
	          [label]="!estAffichageMobile() ? ('GESTION_NAVETTE.TRAJETS.AUJOURDHUI' | translate) : ''">
	</p-button>

	<p-calendar icon="pi pi-calendar"
	            iconDisplay="button"
	            [showIcon]="true"
	            (onSelect)="selectionnerDate($event)"
	            styleClass="calendar-icon-only"
	            appendTo="body"
	            [disabled]="boutonsDesactives()"
	            [minDate]="peutNaviguerDansPasse() ? null : aujourdhui()">
	</p-calendar>
</div>
